/* eslint-disable global-require */
import React from 'react';

import Head from 'next/head';

import Article from '../../Components/Article';
import EducationTab from './Fragments/EducationTab';
import EmployersTab from './Fragments/EmployersTab';
// import AgentTab from './Fragments/AgentTab';
import LearnMore from '../../Components/LearnMore';
import Navbar from '../../Components/Navbar';
import WantToLearnMore from '../../Components/WantToLearnMore';
import Footer from '../../Components/Footer';
import Tabs from '../../Components/Tabs';
import DigitalDisplay from '../../Components/DigitalDisplay';

class About extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta content="EDvice" key="og:title" property="og:title" />
          <meta content="EDvice" key="description" name="description" />
          <meta content="EDvice" key="og:description" property="og:description" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature">
          <DigitalDisplay right color="red" image={require('./Fragments/image1.jpg')}>
            <Article>
              <header className="about__header" id="about">
                <h3>
                  <span>
                    <strong>Why take Linguaskill with EDvice?</strong>
                  </span>
                </h3>
              </header>
              <section className="about__section">
                <p>
                  EDvice is an Authorised Linguaskill Agent for Cambridge Assessment English, part
                  of the University of Cambridge. Through Cambridge Assessment English we offer the
                  world’s leading range of qualifications and tests for learners and teachers of
                  English, globally recognised by more than 20,000 leading universities, employers
                  and governments.
                </p>
              </section>
            </Article>
          </DigitalDisplay>
        </div>
        {/* <div className="background__section"> */}
        {/* <div className="container"> */}
        <Tabs>
          <div label="Linguaskill for Education Institutions" data-active>
            <div className="production-description">
              <EducationTab />
            </div>
          </div>
          <div label="Linguaskill for Employers">
            <EmployersTab />
          </div>
          {/* <div label="Become a Linguaskill Agent">
            <AgentTab />
          </div> */}
        </Tabs>
        {/* </div> */}
        {/* </div> */}
        <LearnMore />
        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default About;
